import 'vxe-table-quantdata/lib/style.css'
import {reportYear} from '../../util/util'
import Vue from 'vue'
import esg_rating_table from '../../esg/components/ESGRatingTable'
import esg_indication_table from '../../esg/components/ESGIndicationTable'
import esg_rating_multi_line_chart from '../../esg/components/ESGRatingMultiLineChart'
Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  components: {esg_rating_table, esg_indication_table, esg_rating_multi_line_chart},
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      report_type: 'rating',
      oaids:[],
      selectEvent: false,
      loading: false,
      report_date: null,
      exportConfig: {},
      report_list: [],
      report_rating_list: [],
      report_year_list: [],
      report_month_list: [],
    }
  },
  methods: {
    generateReport(){
      this.report_year_list=reportYear.esg_report_years
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_month_list = result.report_month_list
        self.report_rating_list = result.report_list
        self.report_year_list=result.report_annual_list
        self.report_list = self.report_rating_list
        self.report_date = self.report_list[0]
      })
    },
    changeReportSelect(){
      if(this.report_type === 'rating'){
        this.report_list = this.report_rating_list
      }else if(this.report_type === 'monthly'){
        this.report_list = this.report_month_list
      }else{
        this.report_list = this.report_year_list
      }
      this.report_date=this.report_list[0]
    },
    getESGData() {
      this.selectEvent = !this.selectEvent
    },

  },
  mounted() {
    this.generateReport()
  },
  watch: {
    report_type: function () {
      this.changeReportSelect()
    }
  },
  created() {
  }
}
Vue.component("compare-home", vm)
export default vm



// WEBPACK FOOTER //
// ./src/compare/js/compare_home.js